import { useQuery } from "@tanstack/react-query";
import { queryOptions } from "../../../../search/hooks";
import { sampleReportKeys } from "../../../queryKeys";
import api from "../api";

const useGetBehaviorGraph = (hash?: string, uploadId?: string) => {
  const { data, isPending } = useQuery({
    ...queryOptions,
    queryKey: sampleReportKeys.getBehaviorGraph(hash, "joe", uploadId),
    queryFn: () => api.getBehaviorGraph(hash, uploadId)
  });

  return {
    items: data?.data,
    isLoading: isPending
  };
};

export default useGetBehaviorGraph;
